<template>
  <div>
    <table class="table table-striped">
        <thead>
          <tr>
            <th v-for="(head,index) in tableHeader" :key="index">{{ head.label | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, idx) in tableList" :key="idx">
            <!-- Order Information -->
            <td v-if="list.trade_no">{{ list.trade_no }}</td>
            <td v-if="list.out_trade_no">{{ list.out_trade_no }}</td>
            <td v-if="list.trade_status">{{ list.trade_status }}</td>
            <td v-if="list.create_time">{{ dateFormat(list.create_time) }}</td>
            <td v-if="list.method">{{ list.method }}</td>
            <td v-if="list.order_amount">{{ list.order_amount }}</td>

            <!-- Product Information -->
            <td v-if="list.app_name">{{ list.app_name }}</td> 
            <td v-if="list.app_id">{{ list.app_id }}</td>
            <td v-if="list.subject">{{ list.subject }}</td>

            <!-- Recurring Information -->
            <td v-if="list.recurring_interval">{{ list.recurring_interval }}</td> 
            <td v-if="list.recurring_quantity">{{ list.recurring_quantity }}</td> 
            <td v-if="list.current_stage">{{ list.current_stage == 0 ? 'Tral' : list.current_stage}}</td> 
            <td v-if="list.trial_amount">{{ list.trial_amount }}</td> 
            <td v-if="list.prev_exec_time">{{ dateFormat(list.prev_exec_time*1000) }}</td> 
            <td v-if="list.next_exec_time">{{ dateFormat(list.next_exec_time*1000) }}</td> 

            <!-- Status History -->
            <td v-if="list.log_status">{{ list.log_status }}</td> 
            <td v-if="list.refund_create_time">{{ dateFormat(list.refund_create_time) }}</td> 
            <td v-if="list.refund_amount">{{ list.refund_amount }}</td> 
            <td v-if="list.callback_status">{{ list.callback_status }}</td> 

            <!-- Buyer Information -->
            <td v-if="list.buyer_name">{{ list.buyer_name }}</td> 
            <td v-if="list.pay_identify">{{ list.pay_identify }}</td> 
            <td v-if="list.muid">{{ list.muid }}</td> 
            <td v-if="list.phone_number">{{ list.phone_number }}</td> 
            <td v-if="list.email">{{ list.email }}</td> 

            <!-- Transactions List -->
            <td v-if="list.child_transaction_id">{{ list.child_transaction_id }}</td> 
            <td v-if="list.child_create_time">{{ list.child_create_time }}</td> 
            <td v-if="list.child_order_amount">{{ list.child_order_amount }}</td> 
            <td v-if="list.child_status">{{ list.child_status }}</td> 

            <!-- <td><a :href="list.download_url" v-if="list.result == 'Generated'"><i class="el-icon-download"></i>Download</a></td> -->
          </tr>
        </tbody>
      </table>
  </div>
</template>
<script>
let moment = require("moment-timezone");
export default {
  name: "RecurringsDetailTable",
  props: {
    tableHeader: {
      type: Array,
      default: () => []
    },
    tableList: {
      type: Array,
      default: () => []
    }
  },
  inject: ['currTimeZone'],
  methods: {
    dateFormat(value) {
      return moment
        .tz(moment.tz(value, "UTC"), this.currTimeZone())
        .format("YYYY-MM-DD HH:mm:ss");
    },
  }
}
</script>